import deviceStore from "./devices/store";
import mobileClocks from "./mobileclocks/store";
import reportStore from "./reports/store";
// import schedulerStore from './scheduler/store';
// import settingsStore from "./settings/store";
import workShiftStore from "./workshift/store";
import shiftScheduler from "./scheduler/store";
import overtimeStore from "./overtime/store";

export default {
  namespaced: true,
  modules: {
    devices: deviceStore,
    mobileClocks: mobileClocks,
    reports: reportStore,
    // scheduler:schedulerStore,
    // settings: settingsStore,
    workshift: workShiftStore,
    scheduler: shiftScheduler,
    overtime: overtimeStore,
  },
};
